<div class="row col-12 p-0 m-0 main-page-section ">
  <!-- <div class="col-1 p-0">
        <app-side-nav [item]="meetingNav"></app-side-nav>
    </div> -->
  <div class="col-12 p-0 container-fluid reports-section">
    <!-- <app-header></app-header> -->
    <div class="col-height">
      <div class="breadcrumbs-section padding-report" *ngIf="fromDetails">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Reports</span>
      </div>

      <div class="breadcrumbs-section" *ngIf="!fromDetails">
        <span class="prev-page pr-1 "><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="prev-page pr-1 "><a routerLink="/employees/employees-list">Employees</a></span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="prev-page pr-1 "><a routerLink="/employees/employees-list/employee-details">Employee
            Details</a></span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Reports</span>
      </div>

      <div class="d-flex justify-content-between padding-report-heading pb-3 pl-5 ml-2">
        <div class="meeting-room-report pointer-link col-9" (clickOutside)="onClickedOutside($event)"
          [autoClose]="'outside'" [ngbPopover]="popContent" triggers="manual" #pr="ngbPopover" (click)="openPopover(pr)"
          placement="bottom" popoverClass='dash-popover dashboard-popover'>
          <span *ngIf="selectedIndex==4">Meeting Room - Admin Report</span>
          <span *ngIf="selectedIndex==3">Meeting Room - Employee Report</span>
          <span *ngIf="selectedIndex==2">Employee Detail Report</span>
          <span *ngIf="selectedIndex==1">Check-in Report</span>
          <span *ngIf="selectedIndex==0">Credit Usage Report</span>
          <img src="../../assets/images/Path.png" class="padding-left-image pr-1" loading="lazy" />
        </div>
        <div>
          <ng-template #popContent>
            <div class="dashboard-popover ">
              <div class="">
                <div class="">
                  <div class="row pb-3 d-flex justify-content-between pointer-link"
                    *ngFor="let report of reportsList;let i=index"
                    (click)="selectedReportType(report.index);openPopover(pr)">
                    <div class="popover-content pl-3 email-width" [class]="selectedIndex==i?'bold-font':'normal-font'">
                      {{report.type}}
                    </div>
                    <div>
                      <img src="/assets/images/tick.png" *ngIf="selectedIndex==i" class="pl-5 " loading="lazy" />
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </ng-template>
        </div>

        <div class="col-3" [ngbPopover]="popDownloadContent" triggers="manual" #pd="ngbPopover"
          (click)="openPopover(pd)"
          *ngIf="!(reportsLoaded && ((selectedIndex==4 && meetings.length == 0) || (selectedIndex==3 && meetings.length == 0) || (selectedIndex==2 && employees.length == 0) || (selectedIndex==1 && checkIns.length == 0) || (selectedIndex==0 && creditPoints.length == 0)))"
          popoverClass='dnload-popover download-popover'>
          <button type="button " class="add-button"><span class="add">Download
              Report&nbsp;&nbsp; &#9660;</span></button>
        </div>

        <div>
          <ng-template #popDownloadContent>
            <div class="download-popover">
              <div class="">
                <div class="">
                  <div class="row pb-3 d-flex justify-content-between pointer-link"
                    *ngFor="let downloadTypes of DownloadTypes"
                    (click)="selectedReportDownload(downloadTypes);openPopover(pd)">
                    <div class="popover-content pl-3 email-width"
                      [class]="SelectedDownloadReportType.includes(downloadTypes?.id) ?'bold-font':'normal-font'">
                      {{downloadTypes.type}}
                    </div>
                    <div>
                      <img src="/assets/images/tick.png"
                        *ngIf="SelectedDownloadReportType.includes(downloadTypes.id) || (downloadTypes.id == null && SelectedDownloadReportType.length == 0)"
                        class="pl-5 " loading="lazy" />
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </ng-template>
        </div>
      </div>
      <div class="col-12 d-flex justify-content-between row borders m-0 p-0 ">
        <div class="col-3  borders-right d-flex justify-content-between relative-content ml-5">

          <div class="pt-3 pb-3" *ngIf="selectedIndex==4" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popMeetingRooms" triggers="manual" #p1="ngbPopover"
            (click)="openPopover(p1)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class=" meeting-label center-align box-size pointer-link text-center meeting-room-head">
            <div class="text">Meeting Room</div>
            <img src="../../assets/images/Path.png" class="pr-3 access-point-arrow" loading="lazy" />
            <div class="meeting-sub-label"> {{multiSelectionMeetingRoom.length>1?selectedMeetingRoom+" +"+
              selctionlength :selectedMeetingRoom}}</div>

            <div>
              <ng-template #popMeetingRooms>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let meetingroom of meetingRooms;let i=index" (click)="selectMeetingRoom(meetingroom);">
                        <div class="popover-content pl-3 email-width"
                          [class]="multiSelectionMeetingRoom.includes(meetingroom?.id) ?'bold-font':'normal-font'">
                          {{meetingroom.name}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionMeetingRoom.includes(meetingroom.id) || (meetingroom.id == null && multiSelectionMeetingRoom.length == 0)"
                            class="pl-5 " loading="lazy" />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </ng-template>
            </div>
          </div>
          <div class="pt-3 pb-3 " *ngIf="selectedIndex==3" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popMeetingRooms" triggers="manual" #p1="ngbPopover"
            (click)="openPopover(p1)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class=" meeting-label center-align box-size pointer-link text-center meeting-room-head">
            <div class="text">Meeting Room</div>
            <img src="../../assets/images/Path.png" class=" pr-3 access-point-arrow" loading="lazy" />
            <div class="meeting-sub-label"> {{multiSelectionMeetingRoom.length>1?selectedMeetingRoom+" +"+
              selctionlength :selectedMeetingRoom}}</div>

            <div>
              <ng-template #popMeetingRooms>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let meetingroom of meetingRooms;let i=index" (click)="selectMeetingRoom(meetingroom);">
                        <div class="popover-content pl-3 email-width"
                          [class]="multiSelectionMeetingRoom.includes(meetingroom?.id) ?'bold-font':'normal-font'">
                          {{meetingroom.name}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionMeetingRoom.includes(meetingroom.id) || (meetingroom.id == null && multiSelectionMeetingRoom.length == 0)"
                            class="pl-5 " loading="lazy" />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </ng-template>
            </div>
          </div>
          <div class="pt-3 pb-3  " *ngIf="selectedIndex==2" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popDepartments" triggers="manual" #p2="ngbPopover"
            (click)="openPopover(p2)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class=" meeting-label center-align box-size pointer-link text-center department-head">
            <div class='text'> Department</div>
            <img src="/assets/images/Path.png" class=" pr-3 access-point-arrow" loading="lazy" />
            <div class="meeting-sub-label">{{multiSelectionDepartments.length>1?selectedDepartment+" +"+ selctionlength
              :selectedDepartment}}</div>

            <div>
              <ng-template #popDepartments>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let department of departments ;let i=index" (click)="selectDepartment(department)">
                        <div class="popover-content pl-3 email-width"
                          [class]="multiSelectionDepartments.includes(department?.id) ?'bold-font':'normal-font'">
                          {{department.department}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionDepartments.includes(department.id) || (department.id == null && multiSelectionDepartments.length == 0)"
                            class="pl-5 " loading="lazy" />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </ng-template>
            </div>

          </div>
          <div class="pt-3 pb-3 " style="top: 40px;" *ngIf="selectedIndex==1" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popAccessPoints" triggers="manual" #p3="ngbPopover"
            (click)="openPopover(p3)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class="meeting-label center-align box-size pointer-link text-center access-point-head">
            <div class='text'>Access Point</div>
            <img src="/assets/images/Path.png" class=" pr-3 access-point-arrow" loading="lazy" />
            <div class="meeting-sub-label"> {{multiSelectionAccessPoints.length>1?selectedAccessPoint+" +"+
              selctionlength :selectedAccessPoint}}</div>

            <div>
              <ng-template #popAccessPoints>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let access of accessPoints ;let i=index" (click)="selectAccessPoint(access)">
                        <div class="popover-content pl-3 email-width"
                          [class]="multiSelectionAccessPoints.includes(access?.id) ?'bold-font':'normal-font'">
                          {{access.accessPointName}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionAccessPoints.includes(access.id) || (access.id == null && multiSelectionAccessPoints.length == 0)"
                            class="pl-5 " loading="lazy" />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </ng-template>
            </div>

          </div>

          <div class="pt-3 pb-3" *ngIf="selectedIndex==0" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popCreditAccess" triggers="manual" #p0="ngbPopover"
            (click)="openPopover(p0)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class="meeting-label center-align box-size pointer-link text-center usage-for">
            <div class="text">Usage for</div>

            <div class="meeting-sub-label">{{selectedUsageType}} <img src="/assets/images/Path.png"
                class=" pr-3 access-point-arrow" loading="lazy" /></div>

            <div>
              <ng-template #popCreditAccess>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let Usagetype of Usagetypes  ;let i=index"
                        (click)="selectCreditUsage(Usagetype);openPopover(p0)">
                        <div class="popover-content pl-3 email-width"
                          [class]="multiSelectionCreditUsageType.includes(Usagetype?.id) ?'bold-font':'normal-font'">
                          {{Usagetype.type}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionCreditUsageType.includes(Usagetype.id) || (Usagetype.id == null  && multiSelectionCreditUsageType.length == 0)"
                            class="pl-5 " loading="lazy" />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </ng-template>
            </div>

          </div>
        </div>


        <div class=" pt-3 pb-3 borders-right col-2 ">

          <div class="pl-3">
            <span class="meeting-label pt-3" style="
                        position: absolute;
                        padding-left: 31px;margin-top: -14px;">From</span>
            <!-- <input class="cal-icon all-hosts pt-3  pointer-link" autocomplete="off"
              (dateSelect)="updateSelectedDate($event)" (click)="d1.toggle()" readonly
              (keypress)="$event.preventDefault()" type="text" name="dp1" ngbDatepicker #d1="ngbDatepicker"> -->

            <input class="cal-icon all-hosts pt-3  pointer-link" (click)="d1.toggle()" [(ngModel)]="fDate" ngbDatepicker
              #d1="ngbDatepicker" (dateSelect)="updateSelectedDate($event)">


            <!-- <div class="meeting-sub-label from-date">{{selectedDate}}</div> -->
            <div class="meeting-sub-label from-date">{{formattedSelectedDate}}</div>

          </div>

        </div>
        <div class="pl-3 pt-3 pb-3 col-2 borders-right  ">
          <span class="meeting-label pt-3" style="
                        position: absolute;
                        padding-left: 31px;margin-top: -14px;">To</span>
          <!-- <input class="cal-icon all-hosts pt-3  pointer-link" autocomplete="off" [readonly]="true"
            (dateSelect)="updateSelectedToDate($event)" (click)="d2.toggle()" (keypress)="$event.preventDefault()"
            type="text" name="dp2" ngbDatepicker #d2="ngbDatepicker"> -->
          <input class="cal-icon all-hosts pt-3  pointer-link" (click)="d2.toggle()" [(ngModel)]="tDate" ngbDatepicker
            #d2="ngbDatepicker" (dateSelect)="updateSelectedToDate($event)">
          <!-- <div class="meeting-sub-label from-date">{{selectedToDate}}</div> -->
          <div class="meeting-sub-label from-date">{{formattedSelectedToDate}}</div>

        </div>
        <div [ngClass]="'col-4'">
          <label for="search">
            <img loading="lazy" [ngClass]="selectedIndex==0?'image-pos-credit':'image-pos'" class=" search-layout"
              src="/assets/images/search.png" alt="search">
            <input class="search-box search-padding placeholder-text " type="text" name="search" id="menu-search"
              [(ngModel)]="searchText" placeholder="Type here to search…">
          </label>
        </div>

      </div>
      <label class="padding-report pt-2 pb-2 column-data" style="margin-top: 10px;"
        *ngIf="(selectedIndex==4 && meetings.length > 0) || (selectedIndex==3 && meetings.length > 0) || (selectedIndex==2 && employees.length > 0) || (selectedIndex==1 && checkIns.length > 0) || (selectedIndex==0 && creditPoints.length > 0)">
        {{selectedIndex==4 || selectedIndex==3 ? (meetings|filter:searchText).length : selectedIndex==2 ?
        (employees|filter:searchText).length :
        selectedIndex==1 ? (checkIns|filter:searchText).length
        : (creditPoints|filter:searchText).length}} results found for you
      </label>

      <empty-state
        *ngIf="reportsLoaded && ( (selectedIndex==4 && meetings.length == 0) || (selectedIndex==3 && meetings.length == 0) || (selectedIndex==2 && employees.length == 0) || (selectedIndex==1 && checkIns.length == 0) || (selectedIndex==0 && creditPoints.length == 0))">
      </empty-state>

    </div>

    <div class="scroll-content " id="content" #content *ngIf="selectedIndex==3  && meetings?.length > 0"
      [ngClass]="{'horizontal-scrollable': meetings.length>0}">
      <table class="table table-borderless table-curved   " *ngIf="meetings.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2" style="text-align: center;"> Sr.No<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('srNo',meetings)"></th>
            <th scope="col">Meeting Room<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('meetingRoomName',meetings)"></th>
            <th scope="col">Membership type<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('userType',meetings)"></th>
            <th scope="col">Organization Name <img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('organisation',meetings)"></th>
            <th scope="col">Member Name <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeName',meetings)"></th>

            <th scope="col">Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('dateOfMeeting',meetings)"></th>
            <th scope="col">Start Time<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('startTime',meetings)"></th>
            <th scope="col">Duration<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('duration',meetings)"></th>

            <th scope="col">Status<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('status',meetings)"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let meeting of meetings | filter:searchText  | paginate: { itemsPerPage: 10,
          currentPage: page,
          totalItems:meetings.length } " [ngClass]="i%2!=0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{meeting.srNo}}</td>
            <td>{{meeting.meetingRoomName}}</td>
            <td>{{meeting.userType}}</td>
            <td>{{meeting.organisation}}</td>
            <td>{{meeting.employeeName}}</td>
            <td>{{formatDate(meeting.dateOfMeeting) }}</td>
            <td>{{meeting.startTime}}</td>
            <td>{{meeting.duration}} hours</td>
            <td>{{meeting.status}}</td>
          </tr>
        </tbody>
      </table>
    </div>



    <div class="scroll-content " id="content" #content *ngIf="selectedIndex==4 && meetings?.length > 0 "
      [ngClass]="{'horizontal-scrollable': meetings.length>0}">
      <table class="table table-borderless table-curved " *ngIf="meetings.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2" style="text-align: center;"> Sr.No<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('srNo',meetings)"></th>
            <th scope="col">Meeting Room<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('meetingRoomName',meetings)"></th>
            <th scope="col">Membership type<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('userType',meetings)"></th>
            <th scope="col">Organization Name <img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('organisation',meetings)"></th>
            <th scope="col">Admin Name <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('bookedBy',meetings)"></th>
            <th scope="col">Member Name <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeName',meetings)"></th>
            <th scope="col">Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('dateOfMeeting',meetings)"></th>
            <th scope="col">Start Time<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('startTime',meetings)"></th>
            <th scope="col">Duration<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('duration',meetings)"></th>
            <th scope="col">Status<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('status',meetings)"></th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let meeting of meetings | filter:searchText | paginate: { itemsPerPage: 10,
        currentPage: page,
        totalItems:meetings.length } " [ngClass]="i%2!=0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;"> {{meeting.srNo}}</td>
            <td>{{meeting.meetingRoomName}}</td>
            <td>{{meeting.userType}}</td>
            <td>{{meeting.organisation}}</td>
            <td>{{meeting.bookedBy}}</td>
            <td>{{meeting.employeeName}}</td>
            <td>{{formatDate(meeting.dateOfMeeting) }}</td>
            <td>{{meeting.startTime}}</td>
            <td>{{meeting.duration}} hours</td>
            <td>{{meeting.status}}</td>
          </tr>
        </tbody>
      </table>
    </div>




    <div class=" scroll-content " *ngIf="selectedIndex==2 && employees.length>0"
      [ngClass]="{'horizontal-scrollable-check-in': employees.length>0}">


      <table class="table table-borderless table-curved" *ngIf="employees.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2" style="text-align: center;">Sr.No<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('srNo',employees)"></th>
            <th scope="col">Member Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('memberName',employees)"></th>
            <th scope="col">Department<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('department',employees)"></th>
            <th scope="col">Onboarded Since<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('onBoardDate',employees)"></th>
            <th scope="col">Ph Number <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('phoneNumber',employees)"></th>

            <th scope="col">Email <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('email',employees)"></th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let employee of employees | filter:searchText | paginate: { itemsPerPage: 10,
            currentPage: page,
            totalItems:employees.length } |filter:searchText" [ngClass]="i%2!=0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{employee.srNo}}</td>
            <td>{{employee.memberName}}</td>
            <td>{{employee.department}}</td>
            <td>{{formatDate(employee.onBoardDate) }}</td>
            <td>{{employee.phoneNumber}}</td>
            <td>{{employee.email}}</td>

          </tr>
        </tbody>
      </table>



    </div>



    <div class="scroll-content " *ngIf="selectedIndex==1 && checkIns?.length > 0"
      [ngClass]="{'horizontal-scrollable-check-in': checkIns.length>0}">



      <table class="table table-borderless table-curved" *ngIf="checkIns.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2" style="text-align: center;">Sr.No<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('srNo',checkIns)"></th>
            <th scope="col">Member Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('memberName',checkIns)"></th>
            <th scope="col">Department<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('designationName',checkIns)"></th>
            <th scope="col">Access Point<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('accessPointName',checkIns)"></th>
            <th scope="col">Date <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('date',checkIns)"></th>
            <th scope="col">Check-in Time <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('timeOfCheckIn',checkIns)"></th>
            <th scope="col">Status<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('status',checkIns)"></th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let checkIn of checkIns | filter:searchText | paginate: { itemsPerPage: 10,
            currentPage: page,
            totalItems:checkIns.length } " [ngClass]="i%2!=0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{checkIn.srNo}}</td>
            <td>{{checkIn.memberName}}</td>
            <td>{{checkIn.designationName}}</td>
            <td>{{checkIn.accessPointName}}</td>
            <td>{{formatDate(checkIn.dateOfCheckIn) }}</td>
            <td>{{checkIn.timeOfCheckIn}}</td>
            <td>{{checkIn.status===true ? 'Access granted' : 'Access denied'}}</td>
          </tr>
        </tbody>
      </table>


    </div>


    <div class="scroll-content " *ngIf="selectedIndex==0 && creditPoints.length>0"
      [ngClass]="{'horizontal-scrollable-membership': creditPoints.length>0}">


      <table class="table table-borderless table-curved" *ngIf="creditPoints.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2" style="text-align: center;">Sr.No<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('srNo',creditPoints)"></th>
            <th scope="col" *ngIf="multiSelectionCreditUsageType==2  ">Admin Name<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('bookedBy',creditPoints)"></th>
            <th scope="col">Employee Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeName',creditPoints)"></th>
            <th scope="col">Meeting Room Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('meetingRoomName',creditPoints)"></th>
            <th scope="col">Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('dateOfMeeting',creditPoints)"></th>

            <th scope="col">Duration<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('duration',creditPoints)"></th>
            <th scope="col">Credit points used<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('creditPointsUsed',creditPoints)"></th>
            <th scope="col">Status<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('status',creditPoints)"></th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let creditPoint of creditPoints | filter:searchText | paginate: { itemsPerPage: 10,
            currentPage: page,
            totalItems:creditPoints.length } " [ngClass]="i%2!=0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{creditPoint.srNo}}</td>
            <td *ngIf="multiSelectionCreditUsageType==2 ">{{creditPoint.bookedBy}}</td>
            <td>{{creditPoint.employeeName}}</td>
            <td>{{creditPoint.meetingRoomName}}</td>
            <td>{{formatDate(creditPoint.dateOfMeeting) }}</td>
            <td>{{creditPoint.duration}} hours</td>
            <td>{{creditPoint.creditPointsUsed}}</td>
            <td>{{creditPoint.status}}</td>


          </tr>
        </tbody>
      </table>



    </div>

    <div class="d-flex justify-content-center pagination-section"
      *ngIf="reportsLoaded && ((selectedIndex==3 || selectedIndex==4) && meetings.length > 10)">
      <div class="row d-flex pagination-border">
        <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeMeeting($event)"
          nextLabel="" class="d-flex justify-content-center">
        </pagination-controls>
        <!-- <div class="pr-3 ratio-class pt-1" *ngIf="meetingRoom?.length>=10">10/{{meetingRooms.length}}</div> -->
        <div class="pr-3 ratio-class pt-1">
          {{meeting?.length}}/{{meetings.length}}</div>
      </div>
    </div>
    <div class="d-flex justify-content-center pagination-section"
      *ngIf="reportsLoaded && (selectedIndex==2 && employees.length > 10) ">
      <div class="row d-flex pagination-border">
        <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeEmployee($event)"
          nextLabel="" class="d-flex justify-content-center">
        </pagination-controls>
        <!-- <div class="pr-3 ratio-class pt-1" *ngIf="employee?.length>=10">10/{{employees?.length}}</div> -->
        <div class="pr-3 ratio-class pt-1">
          {{employee?.length}}/{{employees?.length}}</div>
      </div>
    </div>
    <div class="d-flex justify-content-center pagination-section"
      *ngIf="reportsLoaded && (selectedIndex==1 && checkIns.length > 10) ">
      <div class="row d-flex pagination-border">
        <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeCheckIn($event)"
          nextLabel="" class="d-flex justify-content-center">
        </pagination-controls>
        <!-- <div class="pr-3 ratio-class pt-1" *ngIf="accessPoint?.length>=10">10/{{accessPoints?.length}}</div> -->
        <div class="pr-3 ratio-class pt-1">
          {{checkIn?.length}}/{{checkIns?.length}}</div>
      </div>
    </div>
    <div class="d-flex justify-content-center pagination-section"
      *ngIf="reportsLoaded && (selectedIndex==0 && creditPoints.length > 10)">
      <div class="row d-flex pagination-border">
        <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeCredit($event)"
          nextLabel="" class="d-flex justify-content-center">
        </pagination-controls>
        <!-- <div class="pr-3 ratio-class pt-1" *ngIf="creditPoint?.length>=10">10/{{creditPoints?.length}}</div> -->
        <div class="pr-3 ratio-class pt-1">
          {{creditPoint?.length}}/{{creditPoints?.length}}</div>
      </div>
    </div>
  </div>
</div>